import {DojoDeshi} from '../DojoDeshi.js';
import {DojoTemplates} from '../DojoTemplates.js';
import {Eventify} from '../Eventify.js';
import signals from '../lib/signals.js';

import {FormField} from './FormField.js';
import {FormProxyModel, FormModel} from './FormModel.js';

export class FormGenerator {
	constructor(parent, jsDef, jsData, formSave, formDelete=null, formReload=null) {
		// We ensure that every field has a corresponding data entry.
		// If we don't do this, reset isn't able to reset fields
		// that had not data.
		if (undefined==jsDef.fields) {
			return null;
		}
		for (let f of jsDef.fields) {
			if (undefined == jsData[f.name]) {
				jsData[f.name] = undefined;
			}
		}
		// Our data is now field-complete, so we can create our model
		this.model = new FormProxyModel(new FormModel(jsData));
		this.model.changed.add(this.modelChanged, this);

		[this.el, this.$] = DojoTemplates('formal/FormGenerator');
		if (null==formDelete) {
			this.$.deleteButton.style.display = 'none';
		}
		Eventify(this.el, {
			"save": evt=> {
				evt.preventDefault();
				formSave(this.model.Data, jsDef).then(
					(res)=>{
						this.model.hasChanged = false;
						this.$.saveButton.disabled=true;
						this.$.resetButton.disabled=true;
					},
					(err)=>{
						console.error(`ERROR saving form: `, err);
						alert(`ERROR saving : ${err.message}`);
					}).catch( (err)=>{
						console.error(`ERROR on Form save: `, err);
					});
			},
			"reset": evt=> {
				evt.preventDefault();
				if (null==formReload) {
					this.model.reset();
				} else {
					formReload().then(
						(data)=>{
							this.model.Data = data;
						},
						(err)=>{
							console.error(`ERROR resetting form: `, err);
							alert(`ERROR resetting : ${err.message}`);
						}
					).catch( (err)=> {
						console.error(`ERROR on Form reset:`, err);
					})
				}
			},
			"delete": evt=> {
				evt.preventDefault();
				console.log('formDelete= ', formDelete);
				formDelete(this.model.Data, jsDef).then(
					(deleted)=>{
						if (!deleted) {
							console.log(`did not delete`);
							return;
						}
						// Want to really delete the model
						this.model.deleteForm();
					}).catch( (err)=> {
						console.error(err);
					});
			},
		}, this);
		this.$.saveButton.disabled = true;
		this.$.resetButton.disabled = true;

		// Add the appropriate fields.
		for (let f of jsDef.fields) {
			let fld = new FormField(f, this.model);
			this.$.form.appendChild(fld.DOM);
		}
		parent.appendChild(this.el);
	}
	get DOM() {
		return this.el;
	}
	modelChanged(k,v,model) {
		this.$.saveButton.disabled = !(model.hasChanged);
		this.$.resetButton.disabled = !(model.hasChanged);
		if (null!=this.linkedModel) {
			this.linkedModel.modelChanged(k,v,linkedModel);
		}
	}
	setData(data, model=null) {
		if (null==model) {
			this.model.Data = data;
			return;
		}
		this.model.setSourceModel(model);
	}
}

window.FormGenerator = FormGenerator;
